
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import { PermissionTypeEnum } from '@/libs/Api';

@Component({})
export default class Settings extends Page {
    @Prop() tenantId!: string;

    get useTpm(): boolean {
        return (window as any).UseTpm ?? false;
    }

    get PermissionTypeEnum() {
        return PermissionTypeEnum;
    }
}
